import {Package} from "@/store/api/packageApi";
import {createSlice, PayloadAction} from "@reduxjs/toolkit";

interface PackageState {
    packages: Package[];
}

const initialState: PackageState = {
    packages: [],
}

const packageSlice = createSlice({
    name: "packages",
    initialState,
    reducers: {
        setPackages: (state, action: PayloadAction<Package[]>) => {
            state.packages = action.payload;
        },
        clearPackages: (state) => {
            state.packages = [];
        }
    }
})


export const { setPackages, clearPackages } = packageSlice.actions;
export default packageSlice.reducer;